import { render } from "./quickReply.vue?vue&type=template&id=21859de8"
import script from "./quickReply.vue?vue&type=script&lang=js"
export * from "./quickReply.vue?vue&type=script&lang=js"

import "./quickReply.vue?vue&type=style&index=0&id=21859de8&lang=scss"
script.render = render

export default script